// Renders the award medallions toggled for a product (unicorn / legend).
// Stacked vertically on the center-left so they never overlap each other
// or the corner overlays (category label, arrow, NEW badge, score badge).
export default function ProductBadges({ item, size = 46 }) {
  const badges = [];
  if (item?.badge_unicorn) badges.push(["unicorn", "Unicorn — a rare, special bottle"]);
  if (item?.badge_legend) badges.push(["legend", "Legend — an all-time great"]);
  if (badges.length === 0) return null;

  return (
    <div
      className="absolute right-3 top-3 flex flex-col items-center gap-2 z-10"
      data-testid={`badges-${item.id}`}
    >
      {badges.map(([key, alt]) => (
        <img
          key={key}
          src={`/badges/${key}.jpg`}
          alt={alt}
          title={alt}
          data-testid={`badge-${key}-${item.id}`}
          style={{
            width: size,
            height: size,
            borderRadius: "9999px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.6), 0 0 0 1px rgba(162,140,99,0.5)",
          }}
        />
      ))}
    </div>
  );
}
